import useStatic from "@hooks/useStatic"
import { useRef, useState } from "react"

export default function useStatus(): [Status, Saving] {
    const [state, setState] = useState<Status>("")
    const timeout = useRef<number | undefined>(undefined)

    const clearState = useStatic(() => {
        clearTimeout(timeout.current)
        setState("")
    })

    const saving = useStatic<Saving>(fn => {
        return new Promise(async (resolve, reject) => {
            clearTimeout(timeout.current)

            setState("Saving...")
            resolve(await fn())
            setState("Saved")
    
            timeout.current = setTimeout(clearState, 4000)
        })
    })

    return [state, saving]
}

type Status = "" | "Saving..." | "Saved"
type Saving = <T>(fn: () => Promise<T>) => Promise<T>